import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    token: null,
    sidebarCollapsed: false
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_SIDEBAR_COLLAPSED(state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    CLEAR_USER_DATA(state) {
      state.userInfo = null
      state.token = null
    }
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve) => {
        // 模拟登录
        setTimeout(() => {
          const token = 'mock-token-' + Date.now()
          commit('SET_USER_INFO', userInfo)
          commit('SET_TOKEN', token)
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          localStorage.setItem('token', token)
          resolve()
        }, 1000)
      })
    },
    
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('CLEAR_USER_DATA')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('token')
        resolve()
      })
    },
    
    toggleSidebar({ commit, state }) {
      commit('SET_SIDEBAR_COLLAPSED', !state.sidebarCollapsed)
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo,
    token: state => state.token,
    sidebarCollapsed: state => state.sidebarCollapsed
  }
}) 